import React from 'react'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { useController, UseControllerProps } from 'react-hook-form'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Input } from '@/components/ui/input'

interface Currency {
  code: string
  displayName: string
}

interface Props {
  label?: string
  placeholder?: string
  currenciesData: Currency[]
}

export function InputCurrencyForm(props: Props & UseControllerProps) {
  const { control, name, label, placeholder, currenciesData } = props
  const { field, fieldState } = useController(props)

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const amount = parseFloat(e.target.value) || 0
    field.onChange({ ...field.value, amount })
  }

  const handleCurrencyChange = (codeCurrency: string) => {
    field.onChange({ ...field.value, codeCurrency })
  }

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>
  ): void => {
    // 1. Aserta el tipo de event.target a HTMLInputElement
    const inputElement = event.target as HTMLInputElement

    const allowedKeys = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '.',
      '-',
      'Tab',
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
    ]

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault()
    }

    // Ahora `inputElement.value` está correctamente tipado
    if (event.key === '.' && inputElement.value.includes('.')) {
      event.preventDefault()
    }

    if (event.key === '-') {
      if (
        inputElement.value.includes('-') ||
        inputElement.selectionStart !== 0
      ) {
        event.preventDefault()
      }
    }
  }

  return (
    <FormField
      control={control}
      name={name}
      render={() => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <div className="flex w-full gap-1">
              <Input
                className={'w-2/3'}
                placeholder={placeholder}
                type="number"
                value={field.value?.amount || ''}
                onChange={handleAmountChange}
                onKeyDown={handleKeyDown}
              />
              <div className={'w-1/3'}>
                <Select
                  value={field.value?.codeCurrency || ''}
                  onValueChange={handleCurrencyChange}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Moneda" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      {currenciesData.map((currency) => (
                        <SelectItem key={currency.code} value={currency.code}>
                          {currency.displayName}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </FormControl>
          <FormMessage>{fieldState.error?.message}</FormMessage>
        </FormItem>
      )}
    />
  )
}
